<template>
  <footer class="footer">
    <div class="container">
      <ul class="nav nav-pills nav-justified">
        <li class="nav-item">
          <f7-link href="/dashboard" class="nav-link" :class="{'active': active === 'home'}">
            <span>
                <f7-icon slot="media" f7="house"></f7-icon>
                <span class="nav-text">Trang chính</span>
              </span>
          </f7-link>
        </li>
        <li class="nav-item">
          <f7-link class="nav-link" href="/inbox/danh-sach-ban/" :class="{'active': active === 'chat'}">
              <span>
                <f7-icon slot="media" f7="ant"></f7-icon>
                <span class="nav-text">Chatbot</span>
              </span>
          </f7-link>
        </li>
        <li class="nav-item centerbutton">
          <div class="nav-link" v-click-outside="hide" @click.prevent="toggleCenter" :class="{'active': center_active}">
              <span class="theme-radial-gradient">
                <f7-icon slot="media" class="close" f7="multiply"></f7-icon>
                <f7-icon slot="media" class="nav-icon" f7="circle_grid_3x3_fill"></f7-icon>
              </span>
            <div class="nav-menu-popover">
              <template v-if="user_info.server_region === 'hanoi'">
                <fieldset class="mb-1">
                  <legend>TÍNH NĂNG</legend>
                  <f7-link href="/xu-ly/mb/mb_hanoi">
                    <div class="icon">
                      <img src="../assets/images/calc2.png" alt="Calculator">
                    </div>
                    <span>XỦ LÝ TIN</span>
                  </f7-link>
                  <f7-link href="/du-chuan/mb/mb_hanoi">
                    <div class="icon">
                      <img src="../assets/images/balance.png" alt="Balance">
                    </div>
                    <span>CÂN HÀNG</span>
                  </f7-link>
                  <f7-link href="/inbox/danh-sach-ban/">
                    <div class="icon">
                      <img src="../assets/images/telegram.png" alt="Balance">
                    </div>
                    <span>TELEGRAM</span>
                  </f7-link>
                  <div class="break"></div>
                  <f7-link href="/dashboard">
                    <div class="icon">
                      <img src="../assets/images/chart.png" alt="Balance">
                    </div>
                    <span>CHẠY TRANG</span>
                  </f7-link>
                </fieldset>
              </template>
              <template v-else>
                <fieldset class="mb-1">
                  <legend>XỬ LÝ TIN NHẮN</legend>
                  <template v-for="(item, idx) in center_menus">
                    <f7-link :href="item.link" :key="`calc_${idx}`">
                      <div class="icon">
                        <img src="../assets/images/calc2.png" alt="Calculator">
                      </div>
                      <span>{{ item.name }}</span>
                    </f7-link>
                    <div class="break" v-if="(idx + 1) % 5 === 0" :key="`_br_${idx}`"></div>
                  </template>
                </fieldset>
                <template v-if="!!user_info.user_configs.display_overpoint_function">
                  <div class="break"></div>
                  <fieldset>
                    <legend>CÂN HÀNG</legend>
                    <template v-for="(item, idx) in over_menus">
                      <f7-link :href="item.link" :key="`over_${idx}`">
                        <div class="icon">
                          <img src="../assets/images/balance.png" alt="Balance">
                        </div>
                        <span>{{ item.name }}</span>
                      </f7-link>
                      <div class="break" v-if="(idx + 1) % 5 === 0" :key="`_bro_${idx}`"></div>
                    </template>
                  </fieldset>
                </template>
              </template>
            </div>
          </div>
        </li>
        <li class="nav-item">
          <f7-link class="nav-link" href="/bao-cao-ngay-v3" :class="{'active': active === 'report'}">
              <span>
                <f7-icon slot="media" f7="chart_bar_square"></f7-icon>
                <span class="nav-text">Báo cáo</span>
              </span>
          </f7-link>
        </li>
        <li class="nav-item">
          <f7-link class="nav-link" href="/ca-nhan" :class="{'active': active === 'user_panel'}">
              <span>
                <f7-icon slot="media" f7="person_circle"></f7-icon>
                <span class="nav-text">Cá nhân</span>
              </span>
          </f7-link>
        </li>
      </ul>
    </div>
  </footer>
</template>
<style scoped>
.break {
  flex-basis : 100%;
  height     : 0;
}
.break.bordered {
  border-top : 1px solid rgba(255, 255, 255, 0.6);
  margin     : 10px 0;
}
.nav-menu-popover a.link {
  margin : 0 3px;
}

.nav-menu-popover div.icon {
  width         : 48px;
  height        : 48px;
  background    : rgba(255, 255, 255, 0.3);
  border-radius : var(--fimobile-rounded);
  margin        : 0 auto 3px;
}
.nav-menu-popover div.icon img {
  width       : 36px;
  margin      : 0 auto;
  padding-top : 6px;
}
.nav-menu-popover fieldset {
  /*display: flex;*/
  /*flex-wrap: wrap;*/
  /*justify-content: space-evenly;*/
  width         : 100%;
  border-color  : rgba(255, 255, 255, 0.2);
  border-radius : var(--fimobile-rounded);
}
.nav-menu-popover fieldset legend {
  margin      : 0 auto;
  line-height : 14px;
  font-size   : 12px;
}
</style>
<script>
import ClickOutside from 'vue-click-outside'
import { mapState } from 'vuex';

export default {
  props: {
    active: String
  },
  data() {
    return {
      center_active: 0
    }
  },
  computed: {
    ...mapState(['user_info']),
    center_menus() {
      let menus = [];

      if (!!this.user_info.user_configs.display_mn && !this.user_info.feature_lock) {
        menus.push({
          link: '/xu-ly/mn/default',
          name: 'MN'
        });
      }
      if (!!this.user_info.user_configs.display_mn_mtay && !this.user_info.feature_lock) {
        menus.push({
          link: '/xu-ly/mn/mn_mtay',
          name: 'MN-MTÂY'
        });
      }
      if (!!this.user_info.user_configs.display_mt && !this.user_info.feature_lock) {
        menus.push({
          link: '/xu-ly/mt/default',
          name: 'MT'
        });
      }
      if (!!this.user_info.user_configs.display_mt_mtay && !this.user_info.feature_lock) {
        menus.push({
          link: '/xu-ly/mt/mt_mtay',
          name: 'MT-MTÂY'
        });
      }
      if (!!this.user_info.user_configs.display_mn_buonme && !this.user_info.feature_lock) {
        menus.push({
          link: '/xu-ly/mn/mn_buonme',
          name: 'MN'
        });
      }
      if (!!this.user_info.user_configs.display_mt_buonme && !this.user_info.feature_lock) {
        menus.push({
          link: '/xu-ly/mt/mt_buonme',
          name: 'MT'
        });
      }
      if (!!this.user_info.user_configs.display_mb_buonme && !this.user_info.feature_lock) {
        menus.push({
          link: '/xu-ly/mb/mb_buonme',
          name: 'MB'
        });
      }
      if (!!this.user_info.user_configs.display_mb && !this.user_info.feature_lock) {
        menus.push({
          link: '/xu-ly/mb/default',
          name: 'MB'
        });
      }
      if (!!this.user_info.user_configs.display_mb_mtay && !this.user_info.feature_lock) {
        menus.push({
          link: '/xu-ly/mb/mb_mtay',
          name: 'MB-MTÂY'
        });
      }
      if (!!this.user_info.user_configs.display_mb_ngan && !this.user_info.feature_lock) {
        menus.push({
          link: '/xu-ly/mb/mb_ngan',
          name: 'NGHỆ AN'
        });
      }

      return menus;
    },
    over_menus() {
      let menus = [];

      if (!!this.user_info.user_configs.display_mn && !this.user_info.feature_lock) {
        menus.push({
          link: '/du-chuan/mn/default',
          name: 'MN'
        });
      }
      if (!!this.user_info.user_configs.display_mn_mtay && !this.user_info.feature_lock) {
        menus.push({
          link: '/du-chuan/mn/mn_mtay',
          name: 'MN-MTÂY'
        });
      }
      if (!!this.user_info.user_configs.display_mt && !this.user_info.feature_lock) {
        menus.push({
          link: '/du-chuan/mt/default',
          name: 'MT'
        });
      }
      if (!!this.user_info.user_configs.display_mt_mtay && !this.user_info.feature_lock) {
        menus.push({
          link: '/du-chuan/mt/mt_mtay',
          name: 'MT-MTÂY'
        });
      }
      if (!!this.user_info.user_configs.display_mn_buonme && !this.user_info.feature_lock) {
        menus.push({
          link: '/du-chuan/mn/mn_buonme',
          name: 'MN'
        });
      }
      if (!!this.user_info.user_configs.display_mt_buonme && !this.user_info.feature_lock) {
        menus.push({
          link: '/du-chuan/mt/mt_buonme',
          name: 'MT'
        });
      }
      if (!!this.user_info.user_configs.display_mb_buonme && !this.user_info.feature_lock) {
        menus.push({
          link: '/du-chuan/mb/mb_buonme',
          name: 'MB'
        });
      }
      if (!!this.user_info.user_configs.display_mb && !this.user_info.feature_lock) {
        menus.push({
          link: '/du-chuan/mb/default',
          name: 'MB'
        });
      }
      if (!!this.user_info.user_configs.display_mb_mtay && !this.user_info.feature_lock) {
        menus.push({
          link: '/du-chuan/mb/mb_mtay',
          name: 'MB-MTÂY'
        });
      }
      if (!!this.user_info.user_configs.display_mb_ngan && !this.user_info.feature_lock) {
        menus.push({
          link: '/du-chuan/mb/mb_ngan',
          name: 'NGHỆ AN'
        });
      }

      return menus;
    }
  },
  methods: {
    toggleCenter() {
      this.center_active = !this.center_active;
    },
    hide() {
      this.center_active = 0;
    }
  },
  directives: {
    ClickOutside
  }
}
</script>
